require('./CustomTextField.scss');

const React = require('react'),
    {PropTypes} = require('react'),
    {FontIcon} = require('material-ui'),
    get = require('lodash/object').get,
    ContentUtils = require('utils/ContentUtils');

const TextField = React.createClass({displayName: "TextField",
    propTypes: {
        value: PropTypes.string,
        className: PropTypes.string,
        floatingLabelText: PropTypes.string,
        labelStyle: PropTypes.object,
        errorText: PropTypes.string,
        errorStyle: PropTypes.object,
        onBlur: PropTypes.function,
        onChange: PropTypes.function,
        onFocus: PropTypes.function,
        disabled: PropTypes.boolean,
        multiLine: PropTypes.boolean,
        style: PropTypes.object,
        key: PropTypes.string,
        icon: PropTypes.string,
        onClickIcon: PropTypes.function,
        ref: PropTypes.string
    },

    getInitialState() {
        return {
            isActive: false,
            consumerWrittenText: null
        };
    },

    getValue() {
        return this.getDOMNode().querySelector('input').value;
    },

    componentWillMount() {
        this.id = ContentUtils.getRandomId();
    },

    shouldComponentUpdate(nextProps, nextState) {
        let lastValue;

        if (this.state.consumerWrittenText) {
            lastValue = this.state.consumerWrittenText;
        } else {
            lastValue = this.props.value;
        }

        return nextProps.value !== lastValue ||
            nextProps.errorText !== this.props.errorText ||
            nextProps.floatingLabelText !== this.props.floatingLabelText ||
            nextProps.disabled !== this.props.disabled ||
            nextState.isActive !== this.state.isActive ||
            nextState.consumerWrittenText !== this.state.consumerWrittenText;
    },

    componentDidUpdate() {
        // avoid same cases is out of sync props
        // value which native input value
        let el = this.getDOMNode().querySelector('input');
        if ('' === this.props.value && this.props.value !== get(el, 'value')) {
            this.setState({isActive: false, consumerWrittenText: ''});
            if (ContentUtils.isNotNullOrUndefined(this.props.value) && el) {
                el.value = this.props.value;
            }
        } else if (el && this.props.value !== undefined && this.props.value !== null) {
            el.value = this.props.value;
        }
    },

    onFocus(evt) {
        evt.preventDefault();
        const {onFocus} = this.props;
        if (onFocus) {
            onFocus(evt);
        }
        this.setState({
            isActive: true
        });
    },

    onBlur(evt) {
        evt.preventDefault();
        const {onBlur} = this.props;
        if (onBlur) {
            onBlur(evt);
        }

        this.setState({
            isActive: false,
            consumerWrittenText: evt.target.value
        });
    },

    getInputText() {
        const {
            disabled,
            style,
            value,
            onChange,
            ref
        } = this.props;

        const inputEl = disabled
            ? React.createElement("input", {
                style: style, 
                disabled: true, 
                className: "bp-textfield__input is-disabled", 
                type: "text", 
                id: this.id, 
                defaultValue: value, 
                ref: ref}
            )
            : React.createElement("input", {
                onChange: onChange, 
                onFocus: this.onFocus, 
                onBlur: this.onBlur, 
                style: style, 
                className: "bp-textfield__input", 
                type: "text", 
                defaultValue: value, 
                id: this.id, 
                ref: ref}
            );

        return inputEl;
    },

    getTextArea() {
        const {
            value,
            disabled,
            style,
            onChange,
            ref
        } = this.props;

        const inputEl = disabled
            ? React.createElement("textarea", {
                disabled: true, 
                className: "bp-textfield__input bp-textfield__input--textarea is-disabled", 
                type: "text", 
                id: this.id, 
                defaultValue: value, 
                style: style, 
                ref: ref}
            )
            : React.createElement("textarea", {
                onChange: onChange, 
                style: style, 
                onFocus: this.onFocus, 
                onBlur: this.onBlur, 
                className: "bp-textfield__input bp-textfield__input--textarea", 
                type: "text", 
                id: this.id, 
                defaultValue: value, 
                ref: ref}
            );

        return inputEl;
    },

    render() {
        const {floatingLabelText, errorText, multiLine, value, icon, labelStyle, disabled, errorStyle, className, onClickIcon} = this.props;

        const {isActive, consumerWrittenText} = this.state;

        const inputEl = multiLine ? this.getTextArea() : this.getInputText();
        const consumerWriteText = !!consumerWrittenText;
        const consumerCleanText = consumerWrittenText === '';
        const consumerDefinedValue = !ContentUtils.isNullOrEmpty(value);
        const consumerJustInitializeWithText = (!consumerWriteText && consumerDefinedValue);
        const inputIsInUse = !consumerCleanText && (consumerWriteText || consumerJustInitializeWithText);

        let classNameBuilder = 'bp-textfield';

        if (className) {
            classNameBuilder += ' ' + className;
        }

        if (multiLine) {
            classNameBuilder += ' is-textarea';
        }

        if (isActive) {
            classNameBuilder += ' is-active';
        }

        if (errorText) {
            classNameBuilder += ' have-error';
        }

        if (!floatingLabelText) {
            classNameBuilder += ' is-empty-label';
        }

        if (disabled) {
            classNameBuilder += ' is-disabled';
        }

        if (inputIsInUse || consumerDefinedValue) {
            classNameBuilder += ' is-in-use';
        }

        const floatingLabelTextEl = floatingLabelText
            ? React.createElement("label", {style: labelStyle, className: "bp-textfield__label", htmlFor: this.id}, 
                floatingLabelText
            )
            : null;

        const errorTextEl = errorText
            ? React.createElement("span", {style: errorStyle, className: "bp-textfield__error"}, errorText)
            : null;

        const underline = (
            React.createElement("hr", {className: "bp-textfield__underline"})
        );

        const underlineFixed = (
            React.createElement("hr", {className: "bp-textfield__underline-fixed"})
        );

        const iconEl = icon ? (
            React.createElement(FontIcon, {
                color: {color: '#e0e0e0'}, 
                className: "material-icons bp-textfield__icon", 
                onClick: onClickIcon
            }, 
                icon
            )
        ) : null;

        return (
            React.createElement("div", {key: `${this.id}-textfield-key`, className: classNameBuilder}, 
                inputEl, 
                floatingLabelTextEl, 
                underline, 
                underlineFixed, 
                errorTextEl, 
                iconEl
            )
        );
    }
});


module.exports = TextField;



/** WEBPACK FOOTER **
 ** ./src/components/Commons/TextField/TextField.jsx
 **/